import {init as initEcommerce} from "src/core/checkout";
import eCommerceAnalyticsHandler from "../analytics/ecommerce/middleware";
import TymberBackend from "./tymberBackend";

let lastInitialization = undefined;
export function init(env, DeliveriesService, AuthenticationService, router) {
  if (lastInitialization === env.getEcommerceId()) return;

  lastInitialization = env.getEcommerceId();
  initEcommerce({
    backend: makeBackend(env, DeliveriesService, AuthenticationService),
    middlewares: [eCommerceAnalyticsHandler],
    router: router,
  }).then(() => {});
}

function makeBackend(env, DeliveriesService, AuthenticationService) {
  const prefix = env.getEcommerceId().slice(0, 7) + (env.getAppMode() || "");
  return new TymberBackend(prefix, DeliveriesService, AuthenticationService);
}
